import { getCanonicalLocale as l } from "@nextcloud/l10n";
import { t as o } from "../chunks/l10n-1b905a9a.mjs";
import { n as d } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const u = {
  long: o("a few seconds ago"),
  short: o("seconds ago"),
  // FOR TRANSLATORS: Shorter version of 'a few seconds ago'
  narrow: o("sec. ago")
  // FOR TRANSLATORS: If possible in your language an even shorter version of 'a few seconds ago'
}, f = {
  name: "NcDateTime",
  props: {
    /**
     * The timestamp to display, either an unix timestamp (in milliseconds) or a Date object
     */
    timestamp: {
      type: [Date, Number],
      required: !0
    },
    /**
     * The format used for displaying, or if relative time is used the format used for the title (optional)
     *
     * @type {Intl.DateTimeFormatOptions}
     */
    format: {
      type: Object,
      default: () => ({ timeStyle: "medium", dateStyle: "short" })
    },
    /**
     * Wether to display the timestamp as time from now (optional)
     *
     * - `false`: Disable relative time
     * - `'long'`: Long text, like *2 seconds ago* (default)
     * - `'short'`: Short text, like *2 sec. ago*
     * - `'narrow'`: Even shorter text (same as `'short'` on some languages)
     */
    relativeTime: {
      type: [Boolean, String],
      default: "long",
      validator: (t) => t === !1 || ["long", "short", "narrow"].includes(t)
    },
    /**
     * Ignore seconds when displaying the relative time and just show `a few seconds ago`
     */
    ignoreSeconds: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      /** Current time in ms */
      currentTime: Date.now(),
      /** ID of the current time interval */
      intervalId: void 0
    };
  },
  computed: {
    /** ECMA Date object of the timestamp */
    dateObject() {
      return new Date(this.timestamp);
    },
    /** Time string formatted for main text */
    formattedTime() {
      if (this.relativeTime !== !1) {
        const t = new Intl.RelativeTimeFormat(l(), { numeric: "auto", style: this.relativeTime }), r = (this.dateObject - new Date(this.currentTime)) / 1e3;
        if (Math.abs(r) <= 90)
          return this.ignoreSeconds ? u[this.relativeTime] : t.format(Math.round(r), "second");
        const n = r / 60;
        if (Math.abs(n) <= 90)
          return t.format(Math.round(n), "minute");
        const i = n / 60;
        if (Math.abs(i) <= 24)
          return t.format(Math.round(i), "hour");
        const a = i / 24;
        if (Math.abs(a) <= 6)
          return t.format(Math.round(a), "day");
        const s = a / 7;
        if (Math.abs(s) <= 4)
          return t.format(Math.round(s), "week");
        const m = a / 30;
        return Math.abs(m) <= 12 ? t.format(Math.round(m), "month") : t.format(Math.round(a / 365), "year");
      }
      return this.formattedFullTime;
    },
    formattedFullTime() {
      return new Intl.DateTimeFormat(l(), this.format).format(this.dateObject);
    }
  },
  watch: {
    /**
     * Set or clear interval if relative time is dis/enabled
     *
     * @param {boolean} newValue The new value of the relativeTime property
     * @param {boolean} _oldValue The old value of the relativeTime property
     */
    relativeTime(t, e) {
      window.clearInterval(this.intervalId), this.intervalId = void 0, t && (this.intervalId = window.setInterval(this.setCurrentTime, 1e3));
    }
  },
  mounted() {
    this.relativeTime !== !1 && (this.intervalId = window.setInterval(this.setCurrentTime, 1e3));
  },
  destroyed() {
    window.clearInterval(this.intervalId);
  },
  methods: {
    /**
     * Set `currentTime` to the current timestamp, required as Date.now() is not reactive.
     */
    setCurrentTime() {
      this.currentTime = Date.now();
    }
  }
};
var c = function() {
  var e = this, r = e._self._c;
  return r("span", { staticClass: "nc-datetime", attrs: { "data-timestamp": e.timestamp, title: e.formattedFullTime } }, [e._v(e._s(e.formattedTime))]);
}, h = [], v = /* @__PURE__ */ d(
  f,
  c,
  h,
  !1,
  null,
  null,
  null,
  null
);
const _ = v.exports;
export {
  _ as default
};
